import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { Row } from 'reactstrap';
import styled from 'styled-components';
import { ColNoPadding } from '../../../../../components/Common';
import ExpandIcon from '../../../../../components/ExpandIcon';
import InfoText from '../../../../../components/InfoText';
import ListItem from '../../../../../components/ListItem';
import { SOWING } from '../../../../../res/Constants';
import { getHarvestLines } from '../../../../../utils/Utils';
import { GreenColumn, GreenTimeLine, RedColumn, RedTimeLine, TitleRow } from '../components/Common';

const PLANT_NUMBER = 'Plant Number';
const TRANSPLANT_DATES = 'Transplant Dates';
const NURSERY_DATE = 'Nursery Dates';

export default class SowingTransplating extends PureComponent {
    static propTypes = {
        techFormData: PropTypes.object.isRequired,
        cacType: PropTypes.string.isRequired
    };

    render() {
        const { techFormData, cacType } = this.props;
        const lines = getHarvestLines(cacType, techFormData.contractHarvest);

        return (
            <>
                {isMobileOnly ? (
                    <SowingMobile techFormData={techFormData} lines={lines} />
                ) : (
                    <SowingDesktop techFormData={techFormData} lines={lines} />
                )}
            </>
        );
    }
}

const SowingMobile = ({ techFormData, lines }) => {
    const expandableChildren = (
        <Row>
            <GreenColumn>
                <LineA techFormData={techFormData} lines={lines} />
            </GreenColumn>
            {techFormData.line > 1 && (
                <RedColumn>
                    <LineB techFormData={techFormData} lines={lines} />
                </RedColumn>
            )}
        </Row>
    );

    return (
        <StyledListItem expandableChildren={expandableChildren}>
            {(renderProps) => (
                <TitleRow>
                    <ColNoPadding xs='8' md='12'>
                        <h5>{SOWING}</h5>
                        <p style={{ marginBottom: '0' }}>Transplanting Info</p>
                    </ColNoPadding>
                    <ColNoPadding className='d-md-none' xs='auto'>
                        <ExpandIcon onClick={renderProps.toggleExpand} />
                    </ColNoPadding>
                </TitleRow>
            )}
        </StyledListItem>
    );
};

const SowingDesktop = ({ techFormData, lines }) => {
    return (
        <Row>
            <GreenColumn md='5'>
                <ListItem>{() => <LineA techFormData={techFormData} lines={lines} />}</ListItem>
            </GreenColumn>
            {techFormData.line > 1 && (
                <RedColumn
                    md={{
                        size: 5,
                        offset: 1
                    }}>
                    <ListItem>{() => <LineB techFormData={techFormData} lines={lines} />}</ListItem>
                </RedColumn>
            )}
        </Row>
    );
};

const LineA = ({ techFormData, lines }) => {
    const { plantsNumberA, sowingTransA, nurserySowingA } = techFormData;
    const lineLabel = lines[0];

    return (
        <>
            <h5>Line {lineLabel}</h5>
            <InfoText title={PLANT_NUMBER} content={plantsNumberA} />
            <GreenTimeLine title={TRANSPLANT_DATES} dates={sowingTransA} />
            <GreenTimeLine title={NURSERY_DATE} dates={nurserySowingA} />
        </>
    );
};

const LineB = ({ techFormData, lines }) => {
    const { plantsNumberB, sowingTransB, nurserySowingB } = techFormData;
    const lineLabel = lines[1];

    return (
        <>
            <h5>Line {lineLabel}</h5>
            <InfoText title={PLANT_NUMBER} content={plantsNumberB} />
            <RedTimeLine title={TRANSPLANT_DATES} dates={sowingTransB} />
            <RedTimeLine title={NURSERY_DATE} dates={nurserySowingB} />
        </>
    );
};

const StyledListItem = styled(ListItem)`
    .inner-container-expandable {
        padding: 0;
    }
`;
